import darkFormula from "../themeBuilder/carinaDarkFormula";
import defaultFormula from "../themeBuilder/carinaDefaultFormula";
import { finalizeColorPalette, createColorPalette } from "../themeBuilder/colorPalette";
import { generateAllBackgroundRamps } from "./configurations/index";
import { withExperimentalBlocksTokens } from "./configurations/experimentalBlocksTokens";
import { compose } from "../fn/index";
var carinaPalette = finalizeColorPalette(createColorPalette());
var extendTokens = compose(withExperimentalBlocksTokens, generateAllBackgroundRamps);
export var darkFn = function(options) {
    return extendTokens(darkFormula(carinaPalette, options));
};
export var lightFn = function(options) {
    return extendTokens(defaultFormula(carinaPalette, options));
};
